import { memo, useCallback, useEffect, useMemo, useState } from "react";
import "./content-overview-block.css";
import { Icon } from "../icon/icon";

export const ContentOverviewBlock = memo(
  ({
    title,
    icon,
    defaultOpen = true,
    onToggle,
    children,
    className,
  }) => {
    const [open, setOpen] = useState(!!defaultOpen);

    useEffect(() => {
      setOpen(!!defaultOpen);
    }, [defaultOpen]);

    const toggle = useCallback(() => {
      setOpen((v) => {
        const next = !v;
        onToggle?.(next);
        return next;
      });
    }, [onToggle]);

    const rootClass = useMemo(() => {
      const base = "content-overview-block";
      return className ? `${base} ${className}` : base;
    }, [className]);

    return (
      <div className={rootClass}>
        <button
          type="button"
          className="content-overview-block__header"
          onClick={toggle}
        >
          <div className="content-overview-block__left">
            {icon ? <span className="content-overview-block__icon">{icon}</span> : null}
            <span className="content-overview-block__title">{title}</span>
          </div>

          <Icon
            name={'arrow-left'}
            color={'text-2'}
            className={
              open
                ? "content-overview-block__chevron content-overview-block__chevron--open"
                : "content-overview-block__chevron"
            }
          />
        </button>

        <div
          className={
            open
              ? "content-overview-block__content content-overview-block__content--open"
              : "content-overview-block__content"
          }
        >
          <div className="content-overview-block__content-inner">{children}</div>
        </div>
      </div>
    );
  }
);